import classNames from './StatisticBlock.module.scss';
import classes from 'classnames';
import SVG from 'react-inlinesvg';
import DecreaseArrow from '@/assets/svg/decrease-arrow.svg';
import IncreaseArrow from '@/assets/svg/increase-arrow.svg';
import { useTranslation } from 'react-i18next';

export interface StatisticsBlockProps {
  staticValue: any;
  staticValueDescription?: any;
  staticTitel: string;
  statisticDescription?: any;
  isIncreasing?: boolean;
  descriptionPercents?: number;
  showDescription?: boolean;
}

const StatisticsBlock = ({
  staticValue,
  staticValueDescription,
  staticTitel,
  statisticDescription,
  isIncreasing = true,
  descriptionPercents,
  showDescription = false,
}: StatisticsBlockProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={classNames.statisticValue}>
        <div className={classNames.statisticValueData}>{staticValue}</div>
        {staticValueDescription && (
          <div className={classNames.staticValueDescription}>{staticValueDescription}</div>
        )}
      </div>
      <div className={classNames.statisticTitel}>{t(staticTitel || '')}</div>
      {showDescription && (
        <div className={classNames.DescriptionContainer}>
          {isIncreasing ? <SVG src={IncreaseArrow} /> : <SVG src={DecreaseArrow} />}

          <div
            className={classes(classNames.statisticPercents, {
              [classNames.increase]: isIncreasing,
              [classNames.decrease]: !isIncreasing,
            })}
          >
            {descriptionPercents !== undefined && Number(descriptionPercents.toFixed(2))}%
          </div>

          {statisticDescription && (
            <div className={classNames.statisticDescription}>{statisticDescription}</div>
          )}
        </div>
      )}
    </>
  );
};

export default StatisticsBlock;
